import WirelineDepartments from './WirelineDepartments';

export default WirelineDepartments;
